import { CenterBackground } from '@upright/ui/common/upright/core/impact-lens-profile/frame/center-background';
import { DimensionTitlesWithIcons } from '@upright/ui/common/upright/core/impact-lens-profile/frame/dimension-titles/dimension-title-with-icon';
import { ImpactTitles } from '@upright/ui/common/upright/core/impact-lens-profile/frame/impact-titles';
import { NegativePositiveTitles } from '@upright/ui/common/upright/core/impact-lens-profile/frame/negative-positive-titles';
import { DescriptionsBar } from './descriptions-area/descriptions-bar';
import { HorizontalLines } from './horizontal-lines';
import { ActionBar } from './titles-area/action-bar';
import { VerticalLines } from './vertical-lines';

export function Frame() {
  return (
    <>
      <CenterBackground />
      <ImpactTitles />
      <HorizontalLines />
      <VerticalLines />
      <NegativePositiveTitles />
    </>
  );
}

export function FrameDiv() {
  return (
    <>
      <DescriptionsBar />
      <ActionBar />
      <DimensionTitlesWithIcons />
    </>
  );
}
